import React from 'react'

/** GM cross logo mark - 60x60px, used on category page hero sections */
export const GmCrossIcon = ({
    width = 60,
    height = 59,
    fill = '#F5F1ED',
    ...props
}: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 60 59"
        fill="none"
        {...props}
    >
        <path
            d="M59.053 19.6648V28.0955H44.994C42.9916 28.0955 41.0883 27.6787 39.3674 26.9232C36.1241 25.5111 33.5218 22.9058 32.1086 19.6648C31.3525 17.9453 30.9353 16.0434 30.9353 14.0478V0H39.3674V14.0478C39.3674 17.1481 41.886 19.6648 44.994 19.6648H59.053Z"
            fill={fill}
        />
        <path
            d="M19.6803 0H28.1177V14.0478C28.1177 16.0486 27.7005 17.9505 26.9444 19.67C25.5312 22.911 22.9239 25.5111 19.6803 26.9232C17.9594 27.6787 16.0561 28.0955 14.0589 28.0955H0V19.67H14.0589C17.1616 19.67 19.6803 17.1533 19.6803 14.0478V0Z"
            fill={fill}
        />
        <path
            d="M0 39.335V30.9043H14.0589C16.0613 30.9043 17.9647 31.3211 19.6855 32.0767C22.9291 33.4888 25.5312 36.094 26.9444 39.335C27.7005 41.0546 28.1177 42.9563 28.1177 44.9521V58.9999H19.6855V44.9521C19.6855 41.8517 17.1668 39.335 14.0589 39.335H0Z"
            fill={fill}
        />
        <path
            d="M39.3727 58.9999H30.9353V44.9521C30.9353 42.9513 31.3525 41.0493 32.1086 39.3297C33.5218 36.0887 36.129 33.4888 39.3727 32.0767C41.0936 31.3211 42.9969 30.9043 44.994 30.9043H59.053V39.3297H44.994C41.8913 39.3297 39.3727 41.8464 39.3727 44.9521V58.9999Z"
            fill={fill}
        />
    </svg>
)
